// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Eventos_ListCriteriaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /avaliacoes/eventos/listCriteria
 *
 * Returns every evaluation criterion as an ID-keyed map
 * ({ "<criterion_id>": { ...criterion... } }) built by
 * Avaliacoes_model::mapIDCriteria(). dados IS the map, so getDados()
 * returns the typed property directly.
 */
import type { Eventos_ListCriteriaRow } from './Eventos_ListCriteriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Eventos_ListCriteriaResponseDados = Record<string, Eventos_ListCriteriaRow>;

export type Eventos_ListCriteriaResponse = ApiResponse<Eventos_ListCriteriaResponseDados>;

registerResponseContract('Eventos_ListCriteriaResponse', {})
